<div class="list-wrapper">
  <div class="heading">
    <div class="row">
      <div class="col-2">{{ 'EMAIL_ACTORS.LIST.ACTIVATED' | translate }}</div>
      <div class="col-2">{{ 'EMAIL_ACTORS.LIST.NAME' | translate }}</div>
      <div class="col-3">{{ 'EMAIL_ACTORS.LIST.EMAIL' | translate }}</div>
      <div class="col-5"></div>
    </div>
  </div>
  <div class="items">
    <form [formGroup]="editEmailActorForm">
      <div *ngFor="let item of items">
        <div class="item row" [ngClass]="{ 'edit-row': emailActorInEditMode === item.id, 'static-row': !canEditLine }">
          <div class="content row">
            <ng-container *ngIf="emailActorInEditMode !== item.id">
              <div class="col-md-2 col-sm-12 isActive">
                <eps-checkbox useIconsInReadonly readonly [value]="item.isActive" [showErrors]="false"></eps-checkbox>
              </div>
              <div class="col-md-2 col-sm-12">
                <span class="bold">{{ item.name }}</span>
              </div>
              <div class="col-md-3 col-sm-12">{{ item.email }}</div>
            </ng-container>
            <ng-container *ngIf="emailActorInEditMode === item.id">
                <div class="col-md-2 col-sm-12 isActive">
                  <eps-checkbox useIconsInReadonly readonly formControlName="isActive" [showErrors]="false"></eps-checkbox>
                </div>
                <div class="col-md-2 col-sm-12">
                  <eps-text-input formControlName="name" labelPosition="none" [showErrors]="false"></eps-text-input>
                </div>
                <div class="col-md-3 col-sm-12">
                  <eps-text-input formControlName="email" labelPosition="none" [showErrors]="false"></eps-text-input>
                </div>
            </ng-container>
            <div class="action-buttons col-xl-5 col-md-12 col-sm-12">
              <!-- in view mode -->
              <ng-container *ngIf="!isSaving && canEditLine">
                <eps-button type="link" (buttonClick)="deleteEmailActor.emit(item.id)" label="EMAIL_ACTORS.LIST.DELETE"></eps-button>
                <eps-button (buttonClick)="editEmailActor(item)" buttonIcon="pencilAlt" label="EMAIL_ACTORS.LIST.EDIT"></eps-button>
                <eps-button type="primary" (buttonClick)="deactivateEmailActor.emit(item)" buttonIcon="pencilAlt" [label]="'EMAIL_ACTORS.LIST.' + (item.isActive ? 'DEACTIVATE' : 'ACTIVATE')"></eps-button>
              </ng-container>

              <!-- in edit mode -->
              <ng-container *ngIf="!canEditLine && emailActorInEditMode === item.id">
                <eps-button type="link" (buttonClick)="cancelEditEmailActor()" label="EMAIL_ACTORS.LIST.CANCEL"></eps-button>
                <eps-button
                  (buttonClick)="!isSaving && !editEmailActorForm.invalid && saveEmailActor(editEmailActorForm, false)"
                  [disabled]="editEmailActorForm.invalid"
                  [busy]="isSaving"
                  buttonIcon="save"
                  label="EMAIL_ACTORS.LIST.SAVE"
                ></eps-button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div *ngIf="!isLoading && items.length === 0">
      <span>{{ 'EMAIL_ACTORS.LIST.NO_EMAIL_ACTORS' | translate }}</span>
    </div>

    <div class="loading_spinner" *ngIf="isLoading">
      <i class="fa fa-spinner fa-pulse fa-fw"></i>
    </div>

    <form class="newEmailActorForm" [formGroup]="newEmailActorForm" *ngIf="showNewLine">
      <div class="row new-form">
        <eps-text-input
          formControlName="name"
          label="EMAIL_ACTORS.LIST.NAME"
          labelWidth="140px"
          [showErrors]="false"
        ></eps-text-input>
        <eps-text-input
          formControlName="email"
          label="EMAIL_ACTORS.LIST.EMAIL"
          labelWidth="140px"
          [showErrors]="false"
        ></eps-text-input>
        <div class="col-md-3 col-sm-12 action-buttons">
          <eps-button
            label="EMAIL_ACTORS.LIST.ADD_EMAIL_ACTOR"
            [disabled]="!!newEmailActorForm.invalid"
            (buttonClick)="!newEmailActorForm.invalid && saveEmailActor(newEmailActorForm, true)"
          ></eps-button>
        </div>
      </div>
    </form>
  </div>
</div>
